import { makeObservable, observable, action, runInAction } from "mobx";
import { apiFetch } from "../config/api";

class NotificationsStore {
  notifications = [];

  isLoadingNotifications = false;

  constructor() {
    makeObservable(this, {
      notifications: observable.ref,
      isLoadingNotifications: observable.ref,

      getNotifications: action,
      updateNotification: action,
    });
  }

  getNotifications = () => {
    runInAction(() => {
      this.isLoadingNotifications = true;
    });
    apiFetch("api/license-notifications/")
      .then(({ data }) => {
        console.log('RES: ', data)
        runInAction(() => {
          this.notifications = data;
          this.isLoadingNotifications = false;
        });
      })
      .catch((error) => {
        runInAction(() => {
          this.isLoadingNotifications = false;
        });
      });
  };


  updateNotification = () => {
    runInAction(() => {
      this.isLoadingNotifications = true;
    });
    apiFetch("api/license-notifications/", {
      method: "POST",
    })
      .then(({ data }) => {
        console.log('res: ', data)
        runInAction(() => {
          this.notifications = [];
          this.isLoadingNotifications = false;
        });
      })
      .catch((error) => {
        runInAction(() => {
          this.isLoadingNotifications = false;
        });
      });
  };
}

export default new NotificationsStore();
